import api from 'utils/api';

/**
 * Clean filter params: strips null, undefined, and empty string keys.
 */
function cleanParams(params = {}) {
  const cleaned = {};
  Object.keys(params).forEach((key) => {
    const val = params[key];
    if (val !== undefined && val !== null && val !== '') {
      cleaned[key] = val;
    }
  });
  return cleaned;
}

/**
 * Fetch paginated orders with filters from the backend
 * GET /api/mobile/order/list
 * @param {Object} params - { page, limit, order_status, from, to, search }
 */
export const getOrderList = async (params = {}) => {
  const res = await api.get('/mobile/order/list', {
    params: cleanParams(params)
  });
  return res.data;
};

/**
 * Fetch comprehensive payment and refund details for an order
 * GET /api/admin/payment/order/:orderId
 * @param {string} orderId - Order UUID
 */
export const getOrderPaymentDetail = async (orderId) => {
  const res = await api.get(`/admin/payment/order/${orderId}`);
  return res.data;
};

/**
 * Fetch offer/coupon details for an order that applied a promotion
 * GET /api/offer/:id
 * @param {string} offerId - Offer UUID
 */
export const getOfferDetail = async (offerId) => {
  if (!offerId) return null;
  try {
    const res = await api.get(`/offer/${offerId}`);
    return res.data;
  } catch (err) {
    console.warn(`Failed to fetch offer detail for '${offerId}':`, err.message);
    return null;
  }
};

export default {
  getOrderList,
  getOrderPaymentDetail,
  getOfferDetail
};
